import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Collapse,
  Modal,
  Tabs,
  Tab,
  Form,
} from "react-bootstrap";
import { useHistory } from "react-router";
import { HiRefresh } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { MdCheckCircleOutline, MdOutlineCancel } from "react-icons/md";
import { getActivityPosts, purchaseFromPcari } from "../../Store/actions";

export default function Dashboard() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [selectedModel, setSelectedModel] = useState("all");
  const [showPostModal, setShowPostModal] = useState(false);
  const [unlockItem, setUnlockItem] = useState({
    show: false,
    item: null,
    mode: "featured_post",
    validity: "",
    discounted_price: "",
    error: null,
  });
  const [open, setOpen] = useState(null);
  const { activityPosts } = useSelector((state) => state.Activity);

  const handelModelSelect = (model) => {
    setSelectedModel(model);
  };

  const vehicleTypeDisplayFormater = (type) => {
    if (type === "car" || type === "cars") return "Cars";
    else if (type === "motor" || type === "motors") return "Motorcycle";
    else if (type === "commercial" || type === "commercials")
      return "Commercials";
    else if (type.includes("service")) return "Services";
    else if (type.includes("accessor")) return "Accessories";
    else if (type.includes("rental")) return "Rentals";
    else if (type.includes("apparel")) return "Apparels";
  };

  useEffect(() => {
    //
    if (selectedModel === "all")
      dispatch(getActivityPosts(selectedModel, "published"));
    else if (["cars", "motors", "commercials"].includes(selectedModel))
      history.push("/Vehicles");
    else history.push(selectedModel);
  }, [dispatch, selectedModel]);

  const MODELS = {
    cars: {
      value: "vehicles",
      name: "vehicles",
    },
    // motors: {
    //   value: "motors",
    //   name: "motors",
    // },
    // commercials: {
    //   value: "commercials",
    //   name: "commercials",
    // },
    all_services: {
      value: "all_services",
      name: "services",
    },
    all_parts_accessories: {
      value: "all_parts_accessories",
      name: "accessories",
    },
    all_rentals: {
      value: "all_rentals",
      name: "rentals",
    },
    all_apparels_merchandises: {
      value: "all_apparels_merchandises",
      name: "apparels",
    },
  };

  const mainTile = {
    fontSize: "3rem",
    fontWeight: "bold",
    color: "#11141A",
  };

  const afterMainTile = {
    fontSize: "1.4rem",
    color: "#7F8FA4",
  };

  const secondaryTile = {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "#354052",
  };

  const afterSecondaryTile = {
    fontSize: ".9rem",
    fontWeight: "normal",
    color: "#7F8FA4",
  };

  return (
    <Container className="p-4 my-5 ">
      {/* Headings Start */}
      <Row>
        <Col>
          <h1 style={mainTile}>Seller Dashboard</h1>
          <h4 style={afterMainTile} className="mb-4">
            Welcome Back!
          </h4>
          <h5 style={secondaryTile}>Start Selling</h5>
          <h4 style={afterSecondaryTile} className="mb-4">
            Choose Type of Vehicle you want to sell
          </h4>
        </Col>

        <Row className="mx-auto">
          {Object.values(MODELS).map((model) => (
            <Col key={model.value} md={6} lg={4} xl={3} className="my-1">
              <Card
                className={`border-0 shadwo-sm select-card ${
                  selectedModel !== model.value
                    ? `select-card__${model.name}`
                    : `select-card__${model.name}--selected text-white`
                } cursor-pointer`}
                onClick={() => handelModelSelect(model.name)}
              >
                <Card.Body>
                  <p className="text-capitalize">{model.name}</p>
                </Card.Body>
              </Card>
            </Col>
          ))}
          {/* <Col md={6} lg={4} xl={3} className="d-grid my-1">
            <Button
              variant="primary"
              size="lg"
              className="shadow-none text-white"
              onClick={() => setSelectedModel("all")}
            >
              <HiRefresh className="me-1" />
              Reset Selection
            </Button>
          </Col> */}
        </Row>
      </Row>

      <Row>
        <Col md={6}>
          <h5 style={secondaryTile} className="my-4">
            Your Approved Listings
          </h5>
        </Col>
        <Col md={6} className="d-flex justify-content-md-end">
          <Button
            className="my-4 text-primary border-primary me-2"
            variant="dark"
            size="lg"
            onClick={(e) => setShowPostModal(true)}
          >
            Post New Ad
          </Button>
        </Col>
      </Row>
      {/* Headings Start */}

      {/* Ad start */}
      <Row>
        {activityPosts && activityPosts.data.length > 0 ? (
          activityPosts.data.map((post) => {
            let img = null;
            if (post.media.length) {
              img = post.media.filter((med) => med.name === "1");
              try {
                img = img[0].url;
              } catch (error) {
                img = post.media[0].url;
              }
            }
            return (
              <Col key={post.id} xs={12} className="my-2">
                <Card className="border-0 shadwo-sm rounded-3">
                  <Card.Body className="border-bottom border-light">
                    <Row className="mx-2">
                      <Col
                        xs={3}
                        className="post-img-container rounded-3 d-none d-lg-block"
                      >
                        <img src={img} className="post-img" alt="first" />
                      </Col>
                      <Col sm={6} className="ps-auto ps-lg-4">
                        <p className="fw-bolder my-0 text-primary">
                          <span style={{ color: "#515352" }}>Post:</span> #
                          {post.id}
                        </p>
                        <p className="fw-bolder my-0 text-primary">
                          {post.title}
                        </p>
                        <p
                          style={{ color: "#515352", fontSize: ".8rem" }}
                          className="fw-bolder my-1"
                        >
                          Last Updated: {post.created_at.slice(0, 10)}
                          <span className="text-primary">
                            {post.created_at.slice(10)}
                          </span>
                        </p>
                        <button className="d-block my-2 btn text-tertiary border border-tertiary cursor-text">
                          {vehicleTypeDisplayFormater(post.vehicle_type)}
                        </button>
                        <button className="d-block my-2 btn text-tertiary border border-tertiary cursor-text">
                          Featured
                          {post.is_featured === 1 ? (
                            <MdCheckCircleOutline className="text-success ms-2" />
                          ) : (
                            <MdOutlineCancel className="text-danger ms-2" />
                          )}
                        </button>
                        <button className="d-block my-2 btn text-tertiary border border-tertiary cursor-text">
                          FastDeal
                          {post.is_fast_deal === 1 ? (
                            <MdCheckCircleOutline className="text-success ms-2" />
                          ) : (
                            <MdOutlineCancel className="text-danger ms-2" />
                          )}
                        </button>
                      </Col>
                      <Col
                        sm={6}
                        lg={3}
                        className="d-flex flex-column align-items-sm-center align-items-sm-end"
                      >
                        <button className="d-block mt-4 btn text-primary border border-primary cursor-text">
                          APPROVED
                        </button>
                        <small style={{ color: "#4D4E4E" }}>
                          Comment : {post.comments.length}
                        </small>
                        <Button
                          variant="primary"
                          className="text-white mt-5 shadow-none"
                          size="lg"
                          onClick={() => {
                            setUnlockItem((prev) => {
                              return { ...prev, item: post, show: true };
                            });
                          }}
                        >
                          Unlock features
                        </Button>
                      </Col>
                    </Row>
                  </Card.Body>
                  <Card.Footer className="bg-white">
                    {/* EXPAND  START  */}
                    <Row className="mx-2">
                      <Col>
                        <p
                          style={{ color: "#3100FC" }}
                          className="m-0 cursor-pointer"
                          onClick={() => {
                            if (open === post.id) setOpen(null);
                            else setOpen(post.id);
                          }}
                        >
                          {open === post.id ? "COLLAPSE" : "EXPAND"}
                        </p>
                      </Col>
                    </Row>
                    <Row className="mx-2">
                      <Col>
                        <Collapse in={open === post.id}>
                          <Row>
                            <Col>
                              <button className="d-block my-2 btn text-tertiary border border-tertiary cursor-text">
                                Featured
                                {post.is_featured === 1 ? (
                                  <MdCheckCircleOutline className="text-success mx-2" />
                                ) : (
                                  <MdOutlineCancel className="text-danger mx-2" />
                                )}
                              </button>
                            </Col>
                            <Col>
                              <button className="d-block my-2 btn text-tertiary border border-tertiary cursor-text">
                                Fast Deal
                                {post.is_fast_deal === 1 ? (
                                  <MdCheckCircleOutline className="text-success mx-2" />
                                ) : (
                                  <MdOutlineCancel className="text-danger mx-2" />
                                )}
                              </button>
                            </Col>
                            <Col>
                              <button className="d-block my-2 btn text-tertiary border border-tertiary cursor-text">
                                Bumped
                                {post.is_bumped === 1 ? (
                                  <MdCheckCircleOutline className="text-success mx-2" />
                                ) : (
                                  <MdOutlineCancel className="text-danger mx-2" />
                                )}
                              </button>
                            </Col>
                            <Col>
                              <button className="d-block my-2 btn text-tertiary border border-tertiary cursor-text">
                                Hot Deal
                                {post.is_hot_deal === 1 ? (
                                  <MdCheckCircleOutline className="text-success mx-2" />
                                ) : (
                                  <MdOutlineCancel className="text-danger mx-2" />
                                )}
                              </button>
                            </Col>
                          </Row>
                        </Collapse>
                      </Col>
                    </Row>
                    {/* EXPAND  END  */}
                  </Card.Footer>
                </Card>
              </Col>
            );
          })
        ) : (
          <Card className="border-0 shadow-sm" style={{ minHeight: "30vh" }}>
            <Card.Body className="d-flex justify-content-center align-items-center">
              <p className="text-tertiary">No adds found</p>
            </Card.Body>
          </Card>
        )}
      </Row>
      {/* Ad End */}

      {/*Featurs Modal Start */}
      <Modal
        show={unlockItem.show}
        onHide={() =>
          setUnlockItem((prev) => {
            return {
              ...prev,
              show: false,
              item: null,
              validity: "",
              discounted_price: "",
              mode: "featured_post",
              error: null,
            };
          })
        }
      >
        <Modal.Header>
          <Modal.Title>
            <h1>Unlock Ad Features</h1>
          </Modal.Title>
        </Modal.Header>
        {unlockItem.item && (
          <Modal.Body>
            <Tabs
              defaultActiveKey="feature"
              className="mb-3"
              onSelect={(select) =>
                setUnlockItem((prev) => {
                  return { ...prev, mode: select, error: null, validity: "" };
                })
              }
            >
              <Tab eventKey="feature" title="Featured">
                <h5 style={secondaryTile}>Unlock Featured</h5>
                <p>
                  Unlock Featured to gain more user interaction with your add
                </p>
              </Tab>
              <Tab eventKey="fast_deal" title="Fast Deal">
                <h5 style={secondaryTile}>Unlock Fast Deal</h5>
                <p>
                  Unlock Fast Deal to gain more user interaction with your add
                </p>
              </Tab>
              <Tab eventKey="bump" title="Bumped">
                <h5 style={secondaryTile}>Unlock Fast Deal</h5>
                <p>Unlock Bumped to gain more user interaction with your add</p>
              </Tab>
            </Tabs>
            {unlockItem.mode === "fast_deal" && (
              <Form.Group className="mb-5">
                <Form.Label>
                  Discounted Price<sup className="text-danger">*</sup>
                </Form.Label>
                <Form.Control
                  type="number"
                  isInvalid={unlockItem.error}
                  onChange={(e) =>
                    setUnlockItem((prev) => {
                      return {
                        ...prev,
                        discounted_price: e.target.value,
                        error: null,
                      };
                    })
                  }
                />
              </Form.Group>
            )}
            <Form.Group className="mb-5">
              <Form.Label>
                Pricings<sup className="text-danger">*</sup>
              </Form.Label>
              <Form.Control
                isInvalid={unlockItem.error}
                as="select"
                value={unlockItem.validity}
                onChange={(e) =>
                  setUnlockItem((prev) => {
                    return { ...prev, validity: e.target.value, error: null };
                  })
                }
              >
                <option hidden value>
                  Select
                </option>
                <option value="14">14 Days for RM5</option>
                <option value="30">30 Days for RM10</option>
                <option value="90">90 Days for RM15</option>
              </Form.Control>
            </Form.Group>
            <Row>
              <Col>
                <Button
                  variant="outline-primary"
                  onClick={() => {
                    if (
                      unlockItem.mode === "fast_deal" &&
                      unlockItem.discounted_price !== "" &&
                      unlockItem.validity !== ""
                    ) {
                      dispatch(
                        purchaseFromPcari(
                          "all",
                          unlockItem.mode,
                          unlockItem.item.id,
                          unlockItem.validity,
                          unlockItem.discounted_price,
                          "published"
                        )
                      );
                    } else
                      setUnlockItem((prev) => {
                        return {
                          ...prev,
                          error: "please fill required feilds.",
                        };
                      });

                    if (
                      ["bump", "feature"].includes(unlockItem.mode) &&
                      unlockItem.validity !== ""
                    ) {
                      dispatch(
                        purchaseFromPcari(
                          "all",
                          unlockItem.mode,
                          unlockItem.item.id,
                          unlockItem.validity,
                          undefined,
                          "published"
                        )
                      );
                    } else
                      setUnlockItem((prev) => {
                        return {
                          ...prev,
                          error: "please fill required feilds.",
                        };
                      });

                    setUnlockItem((prev) => {
                      return {
                        ...prev,
                        show: false,
                        item: null,
                        validity: "",
                        discounted_price: "",
                        mode: "featured_post",
                        error: null,
                      };
                    });
                  }}
                >
                  Confirm
                </Button>
              </Col>
            </Row>
          </Modal.Body>
        )}
      </Modal>
      {/*Featurs Modal end */}

      {/*New Ad Modal Start */}
      <Modal show={showPostModal} onHide={() => setShowPostModal(false)}>
        <Modal.Header>
          <Modal.Title>
            <h5 style={secondaryTile}>Start Selling</h5>
            <h4 style={afterSecondaryTile} className="mb-4">
              Choose Type of Vehicle you want to sell
            </h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            {Object.values(MODELS).map((model) => (
              <Col
                key={model.value}
                md={6}
                className="my-1 cursor-pointer shadow-none"
              >
                <Card
                  className={`border-0 shadwo-sm select-card select-card__${model.name}--selected text-white`}
                  onClick={() => {
                    if (["cars", "motors", "commercials"].includes(model.name))
                      history.push("/Vehicles");
                    else history.push(model.name);
                  }}
                >
                  <Card.Body>
                    <p className="text-capitalize">{model.name}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Modal.Body>
      </Modal>
      {/*New Ad Modal Start */}
    </Container>
  );
}
